import { createRoot } from "react-dom/client";

import { CpqQueryClientProvider } from "@4pace-cpq/core";

import { App } from "./App";
import { Providers } from "./Providers";
import "./i18n";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

// Google Analytics is initialized in Providers.tsx, once /env.json has loaded via EnvContext.

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <CpqQueryClientProvider>
      <Providers>
        <App />
      </Providers>
    </CpqQueryClientProvider>,
  );
} else {
  console.error("Root element not found");
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
